/* eslint-disable */

import { fork, all, takeEvery, put } from 'redux-saga/effects';
import _ from 'lodash';
import { GET_LIVE_DETAILS, GET_LIVE_DETAILS_SUCCESS, GET_LIVE_DETAILS_FAIL } from './redux';
import Request from 'app/utils/xhrWrapper';

export function* getLiveDetails() {
  yield takeEvery(GET_LIVE_DETAILS, function* ({ data }) : any {
    try {
      const response = yield Request.get(`live/live/one/tv/${data}`);
      const responseData = _.get(response, ['data']);
      if (responseData) {
        yield put({ type: GET_LIVE_DETAILS_SUCCESS, data: responseData });
      } else {
        yield put({ type: GET_LIVE_DETAILS_FAIL, data: {} });
      }
    } catch (error) {
      yield put({ type: GET_LIVE_DETAILS_FAIL, data: error });
    }
  });
}

export default function* () {
  yield all([
    fork(getLiveDetails),
  ]);
}
